module.exports = __webpack_public_path__ + "media/images/pic/gallery/2019/szkola-letnia-74e1d0eed2c6df535862ff5dd1d6ab74.jpg";